import { logger } from './utils/logger';

// API Configuration
const BASE_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' 
    ? 'https://api.sweetgrassproperties.com'
    : 'http://localhost:3001');

// Ensure BASE_URL doesn't end with /api already
const cleanBaseUrl = BASE_URL.endsWith('/api') 
  ? BASE_URL.slice(0, -4)  // Remove trailing /api
  : BASE_URL;

// API URL for REST endpoints - the backend already includes /api in its routes
export const API_URL = `${cleanBaseUrl}`;

// GraphQL URL for GraphQL endpoint
export const GRAPHQL_URL = `${cleanBaseUrl}/api/graphql`;

// Log configuration in development
if (process.env.NODE_ENV === 'development') {
  logger.debug('Frontend Configuration:', {
    NODE_ENV: process.env.NODE_ENV,
    REACT_APP_API_URL: process.env.REACT_APP_API_URL,
    API_URL,
    GRAPHQL_URL
  });
}
